<template>
    <v-sheet color="transparent">
        <!-- S:: 교육서비스 비주얼 -->
        <v-container class="container--large">
            <main-visual v-if="$vuetify.breakpoint.smAndUp" code="lecture-pc"></main-visual>
            <main-visual v-else code="lecture-mobile"></main-visual>
        </v-container>
        <!-- E:: 교육서비스 비주얼 -->

        <main-section class="pb-0">
            <lecture-categories />
        </main-section>
        <template v-for="(item, index) in items">
            <main-section
                :key="index"
                :class="{
                    [item.className]: true,
                    'pt-0': index == 0,
                }"
            >
                <template v-for="item in item.categories">
                    <lecture-main-list v-bind="item" :key="item._id" />
                </template>
            </main-section>
        </template>
    </v-sheet>
</template>

<script>
import api from "@/api";

import MainVisual from "@/components/client/main/main-visual.vue";
import MainSection from "@/components/client/main/main-section.vue";

import LectureCategories from "@/components/client/lectures/lecture-categories.vue";
import LectureMainList from "@/components/client/lectures/main/lecture-main-list.vue";

export default {
    components: {
        MainVisual,
        MainSection,

        LectureCategories,
        LectureMainList,
    },
    data: () => ({
        categories: [],

        loading: false,
    }),
    computed: {
        items() {
            let items = [];

            let categories = [...this.categories].map((item) => ({
                _id: item._id,
                title: item.name,
                route: {
                    path: "/lectures",
                    query: { category: item.code },
                },
                headers: {
                    limit: 6,
                },
                params: {
                    category: item.code,
                },
            }));
            items.push({
                categories: [...categories.splice(0, 1)],
            });
            items.push({
                className: "grey-f7",
                categories: [
                    {
                        title: "실시간 교육",
                        route: {
                            path: "/lectures",
                            query: { isStream: true },
                        },
                        headers: {
                            limit: 6,
                        },
                        params: {
                            isStream: true,
                        },
                    },
                ],
            });
            items.push({
                categories: [...categories.splice(0, 1)].map((item) => ({ ...item, headers: { limit: 12 } })),
            });
            items.push({
                className: "grey-f7",
                categories: [
                    {
                        title: "MICE Now",
                        route: {
                            path: "/lectures",
                            query: { isMiceNow: true },
                        },
                        headers: {
                            limit: 6,
                        },
                        params: {
                            isMiceNow: true,
                        },
                    },
                ],
            });

            items.push({
                categories: [...categories],
            });

            return items;
        },
    },
    methods: {
        async init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { categories } = await api.v1.lectures.categories.gets({
                    headers: { sort: JSON.stringify({ "main.index": 1, _id: -1 }) },
                    params: { "main.isActive": true },
                });
                this.categories = categories;
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.main-section--link {
    .container.container--large {
        max-width: var(--container-lg);
        padding: 0;
    }
}
::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link {
    padding: 0;
    height: 120px;
    font-size: 2.6rem;
    font-weight: 700;
    overflow: visible;
    &::after,
    &::before {
        content: "";
        position: absolute;
        display: block;
        width: 50vw;
        height: 100%;
        top: 0;
    }
    &::after {
        background-color: var(--v-primary-base);
        opacity: 1;
        z-index: 0;
    }
    &::before {
        z-index: 2;
    }
    .v-btn__content {
        z-index: 1;
    }
    .icon-right-arrow-shadow {
        position: relative;
        left: 0;
        transition: 0.15s ease-out;
    }
}
::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link.v-btn--main-link--left {
    &::after,
    &::before {
        left: unset;
        right: 0;
    }
}
::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link.v-btn--main-link--right {
    &::after,
    &::before {
        left: 0;
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    ::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link {
        height: 160px;
        font-size: 3rem;
    }
}
@media (min-width: 1024px) {
    ::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link {
        height: 200px;
        font-size: 3.6rem;
    }
    ::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link:hover {
        .icon-right-arrow-shadow {
            left: 15px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
